// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const RowContract = contract({
  name: "Row",
  description: "Horizontal composition — button groups, inline form rows, logo + nav rows, anything on one line. Reach for Row instead of `flex items-center gap-*` so the alignment and spacing are editable through the settings panel. For two-pane layouts with an explicit ratio (sidebar + content, 1/3 + 2/3) use Split instead — Row evenly flows whatever children it holds.",
  import: "@gradeui/ui",
  aliases: ["row","hstack","horizontal","inline","horizontal layout","hstack","h-stack","horizontal stack","lazyhstack"],
  composesWith: ["Button","Input","NavItem","Stack (can wrap a Row)","any content component"],
  styleDefaults: {"Row":"gds-row flex flex-row gap-4 items-center justify-start"},
  variantDefaults: {"gap":"md","align":"center","justify":"start"},
  props: {
  "gap": {
      schema: z.enum(["none", "xs", "sm", "md", "lg", "xl", "2xl"]).optional(),
      design: "knob",
      description: "gap between children",
      default: "md",
  },
  "align": {
      schema: z.enum(["start", "center", "end", "stretch", "baseline"]).optional(),
      design: "knob",
      description: "cross-axis (vertical) alignment",
      default: "center",
  },
  "justify": {
      schema: z.enum(["start", "center", "end", "between", "around", "evenly"]).optional(),
      design: "knob",
      description: "main-axis distribution",
      default: "start",
  },
  "wrap": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "allow children to wrap onto additional lines when they overflow",
      default: false,
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Slot",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
